import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth, dashboardPathFor } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import RedeCredenciada from "@/pages/RedeCredenciada";
import PublicHeader from "@/components/PublicHeader";

import DashboardLayout from "@/components/DashboardLayout";
import ClienteDashboard from "@/pages/dashboards/ClienteDashboard";
import CredenciadoDashboard from "@/pages/dashboards/CredenciadoDashboard";
import VendedorDashboard from "@/pages/dashboards/VendedorDashboard";
import GestorDashboard from "@/pages/dashboards/GestorDashboard";
import GestorRede from "@/pages/dashboards/GestorRede";
import GestorCredenciados from "@/pages/dashboards/GestorCredenciados";
import GestorEmpresas from "@/pages/dashboards/GestorEmpresas";
import GestorClientes from "@/pages/dashboards/GestorClientes";
import GestorFinanceiro from "@/pages/dashboards/GestorFinanceiro";
import GestorRelatorios from "@/pages/dashboards/GestorRelatorios";
import CredenciarPublic from "@/pages/CredenciarPublic";

function PublicShell({ children }) {
  return (
    <>
      <PublicHeader />
      <div>{children}</div>
    </>
  );
}

function DashboardRedirect() {
  const { user } = useAuth();
  return <Navigate to={dashboardPathFor(user?.role)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<PublicShell><Landing /></PublicShell>} />
          <Route path="/planos" element={<PublicShell><Landing /></PublicShell>} />
          <Route path="/sobre" element={<PublicShell><Landing /></PublicShell>} />
          <Route path="/rede" element={<RedeCredenciada />} />
          <Route path="/entrar" element={<Login />} />
          <Route path="/cadastro" element={<Register />} />
          <Route path="/credenciar/:token" element={<CredenciarPublic />} />

          <Route path="/painel" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />

          <Route path="/painel/cliente" element={<ProtectedRoute roles={["cliente"]}><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<ClienteDashboard />} />
            <Route path="rede" element={<RedeCredenciadaInline />} />
          </Route>

          <Route path="/painel/credenciado" element={<ProtectedRoute roles={["credenciado"]}><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<CredenciadoDashboard />} />
            <Route path="registrar" element={<CredenciadoDashboard />} />
          </Route>

          <Route path="/painel/vendedor" element={<ProtectedRoute roles={["vendedor"]}><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<VendedorDashboard />} />
            <Route path="leads" element={<VendedorDashboard />} />
          </Route>

          <Route path="/painel/gestor" element={<ProtectedRoute roles={["gestor"]}><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<GestorDashboard />} />
            <Route path="rede" element={<GestorCredenciados />} />
            <Route path="rede-legacy" element={<GestorRede />} />
            <Route path="empresas" element={<GestorEmpresas />} />
            <Route path="clientes" element={<GestorClientes />} />
            <Route path="financeiro" element={<GestorFinanceiro />} />
            <Route path="relatorios" element={<GestorRelatorios />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

function RedeCredenciadaInline() {
  return <div className="-m-6 lg:-m-10"><RedeCredenciada /></div>;
}

export default App;
